import React, { useState, useContext, useEffect } from "react";
import { IoSearch } from "react-icons/io5";
import FilterSelect from "../common/FilterSelect";
import { useNavigate } from "react-router-dom";
import { RiAccountCircleFill } from "react-icons/ri";
import AppContext from "../../context/AppContext";
import Cookies from "js-cookie";
import translations from "../common/Translations";
import CommonButton from "../common/CommonButton";
const UserToolbar = ({ onFilterChange, onSearch, onAreaSearch }) => {
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"))
  const handleNavigate = () => {
    navigate("/add-user");
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUserType, setSelectedUserType] = useState("");
  const [searchArecodeTerm, setSearchArecodeTerm] = useState("");
  const { theme, langMode } = useContext(AppContext);
  const userType = [
    { id: "", value: "Default" }, // Adding an "Everything" option
    { id: "super_admin", value: "super_admin" },
    { id: "admin", value: "admin" },
    { id: "office_user", value: "office_user" },
    { id: "field_agent", value: "field_agent" },
  ];
  const [filteredUserType, setFilteredUserType] = useState(userType);

  useEffect(() => {
    const userVisibility = Cookies.get("userVisibility");
    const userTypeCookie = Cookies.get("userType");
    let allowedUserTypes = [...userType];

    if (userTypeCookie === "super_admin") {
      allowedUserTypes = allowedUserTypes.filter(
        (type) => type.id !== "super_admin"
      );
    } else if (userTypeCookie === "admin") {
      allowedUserTypes = allowedUserTypes.filter(
        (type) => type.id !== "super_admin" && type.id !== "admin"
      );
    } else if (userTypeCookie === "office_user") {
      if (userVisibility === "field_agent") {
        allowedUserTypes = allowedUserTypes.filter(
          (type) => type.id === "field_agent"
        );
      } else if (userVisibility === "office_user") {
        allowedUserTypes = allowedUserTypes.filter(
          (type) => type.id === "office_user"
        );
      } else if (
        userVisibility === "office_user,field_agent" ||
        userVisibility === "field_agent,office_user"
      ) {
        allowedUserTypes = allowedUserTypes.filter(
          (type) => type.id === "office_user" || type.id === "field_agent"
        );
      }
    } else if (userTypeCookie === "field_agent") {
      if (userVisibility === "field_agent") {
        allowedUserTypes = allowedUserTypes.filter(
          (type) => type.id === "field_agent"
        );
      }
    } else {
      allowedUserTypes = userType;
    }
    setFilteredUserType(allowedUserTypes);
  }, []);

  const handleUserTypeChange = (value) => {
    setSelectedUserType(value);
    onFilterChange("userType", value === "Default" ? "" : value); // Pass null if "Everything" is selected
  };
  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);

    if (term === "") {
      onSearch(term);
      onFilterChange("userName", term);
    }
  };

  const handleSearchUserName = () => {
    onSearch(searchTerm);
    onFilterChange("userName", searchTerm);
  }

  const handleAreacodeSearchChange = (event) => {
    const areacodeterm = event.target.value;
    setSearchArecodeTerm(areacodeterm);
    onAreaSearch(areacodeterm);
    onFilterChange("areacode", areacodeterm);
  };

  return (
    <div className={`flex xl:flex-nowrap lg:flex-nowrap md:flex-nowrap sm:flex-nowrap flex-wrap justify-between xl:items-center lg:items-center md:items-center sm:items-center items-start xl:pr-10 lg:pr-10 md:pr-10 sm:pr-10 pr-0 gap-1  `}>
      <div className="flex flex-col md:flex-row gap-2">

        <div
          className={` bg-white flex flex-col xsm:flex-row gap-3 ${theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
              ? "high-contrast"
              : ""
            }`}
        >
          <div
            className={` bg-white ${langMode === 'ar' ? 'mt-1 ' : 'mt-0'} ${theme === "dark"
              ? "dark-mode  "
              : theme === "high-contrast"
                ? "high-contrast  "
                : ""
              }`}
          >   <div className="flex w-full">
              <div className="relative mt-1 w-full">
                <input
                  id="account-search"
                  autoComplete="new-password" // Alternative to prevent autofill
                  type="text"
                  className={`block h-8 pt-2  text-sm text-gray-900 border border-gray-300 ${langMode === 'ar' ? 'rounded-r-md ' : 'rounded-l-md'}   xl:w-44 lg::w-44 md::w-44 sm::w-44 w-auto
               focus:ring-blue-300 focus:border-blue-300  
                ${theme === "dark"
                      ? "dark-mode  "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                    }`}
                  placeholder={translations[langMode].searchusername}
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </div>

              <button
                onClick={handleSearchUserName}
                className={`h-8 px-4 mt-1 bg-[#236DB4] text-white  ${langMode === 'ar' ? 'rounded-l-md  ' : 'rounded-r-md '}`}
              >
                <IoSearch size={20} />{" "}
              </button>
            </div>

          </div>

          <FilterSelect
          options={filteredUserType}
          defaultText={translations[langMode].userType}
          value={selectedUserType}
          onChange={handleUserTypeChange}
        />
        </div>

      
      </div>
      <div className="flex">
        {/* <button
          type="button"
          className="px-3 py-2 text-xs font-medium text-center inline-flex items-center text-white bg-blue-800 rounded-lg hover:bg-blue-900 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          onClick={handleNavigate}
        >
          <RiAccountCircleFill className="w-5 h-5 mr-2" />
          {translations[langMode].addUser}
        </button> */}

       {userDetails?.canAddEditUser && <CommonButton onClick={handleNavigate} variant="primary">
          <RiAccountCircleFill className="w-5 h-5" title="add user" />
          <span className="xl:flex lg:flex md:flex sm:flex hidden">{translations[langMode].addUser}</span>
        </CommonButton>}
      </div>
    </div>
  );
};

export default UserToolbar;
